module.exports = __webpack_public_path__ + "static/media/videoBadgeLevel1Locked.e269986c.png";